import { render, staticRenderFns } from "./InactivityDialog.vue?vue&type=template&id=b4d25c72"
import script from "./InactivityDialog.vue?vue&type=script&lang=js"
export * from "./InactivityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports